import { useState, useRef } from "react";

const FORM_URL = "https://readdy.ai/api/form/d70fdouth28qd804cpu0";

export default function ContactSection() {
  const [charCount, setCharCount] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value as string);
    });

    setSubmitting(true);
    setError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
        form.reset();
        setCharCount(0);
      } else {
        setError("提交失敗,請稍後再試。");
      }
    } catch {
      setError("網絡錯誤,請稍後再試。");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            <div>
              <div className="inline-block px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full mb-4">
                聯繫我們
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
                開啟您的
                <br />
                水果進口之旅
              </h2>
              <p className="text-gray-600 leading-relaxed">
                無論您是批發商、零售商還是進口商,我們都能為您提供專業的水果出口服務。填寫表單或直接聯繫我們,讓我們一起探討合作機會。
              </p>
            </div>
            <div className="space-y-6">
              {[
                {
                  icon: "ri-map-pin-line",
                  title: "公司地址",
                  lines: ["123 Nguyen Hue Street, District 1, Ho Chi Minh City, Vietnam"],
                },
                {
                  icon: "ri-phone-line",
                  title: "聯繫電話",
                  lines: ["+84 33 838 9340", "+84 33 838 9340 (WhatsApp)"],
                },
                {
                  icon: "ri-mail-line",
                  title: "電子郵箱",
                  lines: ["export@farmersbasket.vn", "sales@farmersbasket.vn"],
                },
                {
                  icon: "ri-time-line",
                  title: "工作時間",
                  lines: ["週一至週五:8:00 - 18:00", "週六:8:00 - 12:00"],
                },
              ].map((item, i) => (
                <div key={i} className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-xl text-orange-700`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
                    {item.lines.map((l, j) => (
                      <p key={j} className="text-gray-600">{l}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="pt-6">
              <h3 className="font-semibold text-gray-900 mb-4">關注我們</h3>
              <div className="flex space-x-3">
                {[
                  { icon: "ri-facebook-fill", href: "#" },
                  { icon: "ri-instagram-line", href: "#" },
                  { icon: "ri-linkedin-fill", href: "#" },
                  { icon: "ri-whatsapp-line", href: "#" },
                ].map((s, i) => (
                  <a
                    key={i}
                    href={s.href}
                    className="w-10 h-10 flex items-center justify-center bg-orange-100 text-orange-700 rounded-full hover:bg-orange-700 hover:text-white transition-colors cursor-pointer"
                  >
                    <i className={s.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="bg-gray-50 rounded-3xl p-8 lg:p-10">
            {submitted ? (
              <div className="flex flex-col items-center justify-center h-full py-16 space-y-4">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full">
                  <i className="ri-check-line text-3xl text-orange-700"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">提交成功！</h3>
                <p className="text-gray-600 text-center">感謝您的諮詢，我們的團隊將在24小時內與您聯繫。</p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="px-6 py-2.5 bg-orange-700 text-white rounded-full text-sm font-medium hover:bg-orange-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  再次提交
                </button>
              </div>
            ) : (
              <form
                ref={formRef}
                id="contact-form"
                data-readdy-form="true"
                className="space-y-6"
                onSubmit={handleSubmit}
              >
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      姓名 *
                    </label>
                    <input
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
                      placeholder="請輸入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      電子郵箱 *
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                      公司名稱 *
                    </label>
                    <input
                      id="company"
                      name="company"
                      required
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
                      placeholder="請輸入公司名稱"
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      Whatsapp/Wechat
                    </label>
                    <input
                      id="phone"
                      name="phone"
                      type="text"
                      required
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
                      placeholder="請輸入 WhatsApp 號碼 或 WeChat ID"
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-2">
                      國家/地區 *
                    </label>
                    <input
                      id="country"
                      name="country"
                      required
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
                      placeholder="請輸入國家或地區"
                    />
                  </div>
                  <div>
                    <label htmlFor="product" className="block text-sm font-medium text-gray-700 mb-2">
                      感興趣的產品 *
                    </label>
                    <select
                      id="product"
                      name="product"
                      required
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm cursor-pointer"
                    >
                      <option value="">請選擇產品</option>
                      <option value="火龍果">火龍果</option>
                      <option value="芒果">芒果</option>
                      <option value="榴槤">榴槤</option>
                      <option value="山竹">山竹</option>
                      <option value="紅毛丹">紅毛丹</option>
                      <option value="其他">其他</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label htmlFor="quantity" className="block text-sm font-medium text-gray-700 mb-2">
                    預計採購量
                  </label>
                  <input
                    id="quantity"
                    name="quantity"
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
                    placeholder="例如:每月10噸"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    留言
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    maxLength={500}
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm resize-none"
                    placeholder="請告訴我們您的需求或問題(最多500字)"
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1 text-right">{charCount}/500</div>
                </div>
                {error && <p className="text-red-500 text-sm">{error}</p>}
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-3.5 bg-orange-700 text-white font-medium rounded-full hover:bg-orange-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {submitting ? "提交中..." : "提交諮詢"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
